import React, {Component} from 'react';
import {connect} from 'react-redux';
import {find} from 'lodash';
import {Card, Button, Icon} from 'semantic-ui-react';
import {getNextInfoType, getInfoStockData, getTotalStock} from '../../utils';
import {Actions} from '../../../../common/actions';
import BarChart from '../charts/bar';

class StockByDealers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'infoType': 'dealers',
      'dealerSelected': '',
      'modelSelected': '',
      'reservedDealerIdSelected': '',
    };
  }

  componentDidMount() {
    this.props.clearVehiclesStock();
    this.getStockData();
  }

  componentDidUpdate(prevProps) {
    const {infoType} = this.state;
    const {stockByDealersList, stockByModelsList, stockByReservationsList, stockByColorsList} = this.props;
    if (prevProps.stockByDealersList !== stockByDealersList ||
      prevProps.stockByModelsList !== stockByModelsList ||
      prevProps.stockByReservationsList !== stockByReservationsList ||
      prevProps.stockByColorsList !== stockByColorsList) {
      const total = getTotalStock(infoType, this.props);
      this.props.onUpdateTotalQuantity(total);
    }
  }

  getStockData = () => {
    const {infoType, dealerSelected, modelSelected, reservedDealerIdSelected} = this.state;
    const queryString = {infoType};

    if (dealerSelected) {
      queryString.dealer = dealerSelected;
    }
    if (modelSelected) {
      queryString.model = modelSelected;
    }
    if (reservedDealerIdSelected) {
      queryString.reservedDealerId = reservedDealerIdSelected;
    }
    this.props.fetchVehiclesStock(queryString);
  }

  onBarClick = (code, infoType) => {
    const nextInfoType = getNextInfoType(infoType, 'stock dealers');
    const newState = {'infoType': nextInfoType};
    if (nextInfoType === 'models') {
      newState.dealerSelected = code;
    }
    if (nextInfoType === 'reservations') {
      newState.modelSelected = code;
    }
    if (nextInfoType === 'colors') {
      newState.reservedDealerIdSelected = code;
    }
    this.setState(newState, () => this.getStockData());
  }

  onUpdateDealerClick = () => {
    this.setState({
      'infoType': 'dealers',
      'dealerSelected': '',
      'modelSelected': '',
      'reservedDealerIdSelected': '',
    }, () => this.getStockData());
  }

  onUpdateModelClick = () => {
    this.setState({
      'infoType': 'models',
      'modelSelected': '',
      'reservedDealerIdSelected': '',
    }, () => this.getStockData());
  }

  
  onUpdateReservedDealerClick = () => {
    this.setState({
      'infoType': 'reservations',
      'reservedDealerIdSelected': '',
    }, () => this.getStockData());
  }

  renderDealerSelected = () => {
    const {dealerSelected} = this.state;
    const {stockByDealersList} = this.props;
    if (!dealerSelected) {
      return null;
    }
    const dealerInfo = find(stockByDealersList, {'code': dealerSelected}) || {};

    return (
      <Button
        type='button'
        primary
        className='toyota-primary'
        onClick={this.onUpdateDealerClick}
      >
        {dealerInfo.name}
        <Icon name='close' size='small' />
      </Button>
    );
  }

  renderModelSelected = () => {
    const {modelSelected} = this.state;
    if (!modelSelected) {
      return null;
    }
    return (
      <Button
        type='button'
        primary
        className='toyota-primary'
        onClick={this.onUpdateModelClick}
      >
        {modelSelected}
        <Icon name='close' size='small' />
      </Button>
    );
  }

  renderReservedDealerSelected = () => {
    const {reservedDealerIdSelected} = this.state;
    const {stockByReservationsList} = this.props;
    if (!reservedDealerIdSelected) {
      return null;
    }

    const dealerInfo = find(stockByReservationsList, {'code': reservedDealerIdSelected}) || {};
    return (
      <Button
        type='button'
        primary
        className='toyota-primary'
        onClick={this.onUpdateReservedDealerClick}
      >
        {dealerInfo.name}
        <Icon name='close' size='small' />
      </Button>
    );
  }

  clearFiltersSelected = () => {
    const {dealerSelected} = this.state;
    if (!dealerSelected) {
      return null;
    }

    return (
      <Button
        type='button'
        primary
        className='toyota-primary'
        onClick={this.onUpdateDealerClick}
      >
        Limpiar Filtros
        <Icon name='close' size='small' />
      </Button>
    );
  }

  showFiltersSelectedSection = () => {
    return (
      <div className='title-bar filters-selected-section'>
        <div className='title'>
          <h4>Filtros Seleccionados: </h4>
          {this.renderDealerSelected()}
          {this.renderModelSelected()}
          {this.renderReservedDealerSelected()}
          <div className='title-bar-actions'>
            {this.clearFiltersSelected()}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {loading} = this.props;
    const {infoType} = this.state;
    return (
      <Card fluid raised>
        {this.showFiltersSelectedSection()}
        <BarChart
          loading={loading}
          data={getInfoStockData(infoType, this.props)}
          infoType={infoType}
          onActiveBarClick={this.onBarClick}
        />
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.vehiclesKpi.loading,
    'stockByDealersList': state.vehiclesKpi.stockByDealersList,
    'stockByModelsList': state.vehiclesKpi.stockByModelsList,
    'stockByReservationsList': state.vehiclesKpi.stockByReservationsList,
    'stockByColorsList': state.vehiclesKpi.stockByColorsList,
  };
};

const {
  clearVehiclesStock,
  fetchVehiclesStock,
} = Actions;

export default connect(mapStateToProps, {
  clearVehiclesStock,
  fetchVehiclesStock,
})(StockByDealers);
